
import BackButton from '@/components/UI/backButton/BackButton.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    BackButton,
  },
})
export default class Errors extends Vue {}
